import i18n from '@/plugins/i18n';

export default () => {
  return {
    fields: [
      {
        key: 'actions',
        label: i18n.t('Actions')
      },
      {
        key: 'country',
        label: i18n.t('Country')
      },
      {
        key: 'state',
        label: i18n.t('State')
      },
      {
        key: 'city',
        label: i18n.t('City')
      },
      {
        key: 'action_name',
        label: i18n.t('Actions (Links)')
      },
      {
        key: 'action_token',
        label: i18n.t('Token')
      },
      {
        key: 'campaign_name',
        label: i18n.t('Campaign')
      },
      {
        key: 'url',
        label: 'URL'
      }
    ]
  };
};
